import React, { useEffect, useRef, useState } from 'react'
import { FallingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Switch from "react-switch";
import { toast } from "react-toastify";
import Background1 from "../../assets/images/Background1.jpg";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import axios from "../../components/Hooks/axios";
import EnablePollContainer from "./EnablePollContainer";
import CustomPollModal from "./CustomPollModal";
import styles from './UploadPost.module.scss'
import { FaArrowLeftLong } from 'react-icons/fa6';
import SearchIcon from '../../assets/images/search.png';
import { validateMediaFile, getFriendlyUploadErrorMessage } from "../../utils/fileValidation";
import AskFameoAssistantModal from "../../components/AskFameo/AskFameoAssistantModal";
import { cleanCaptionSentence } from "../../utils/cleanCaptionSentence";
import { PiMagicWandFill } from "react-icons/pi";

// Global cache for stable blob URLs to prevent video/image buffering
const blobCache = new WeakMap();
const getStableUrl = (file) => {
    if (!file) return null;
    if (typeof file === "string") return file; // Already a URL
    if (!blobCache.has(file)) {
        blobCache.set(file, URL.createObjectURL(file));
    }
    return blobCache.get(file);
};

function UploadPost2() {
    const navigate = useNavigate();
    const data = useLocation();
    const { userId } = useSelector((state) => state.auth);

    const [fileData, setFileData] = useState(data?.state?.fileData);
    const [fileType, setFileType] = useState(data?.state?.fileType);
    const imageRef = useRef(null);
    const [enablePoll, setEnablePoll] = useState(false);
    const [showPollResults, setShowPollResults] = useState(false);
    const [timer, setTimer] = useState("0");
    const [caption, setCaption] = useState(data?.state?.caption === undefined ? "" : data?.state?.caption);
    const [tag, setTag] = useState([]);
    const [tagText, setTagText] = useState(""); // New state for raw hashtag input
    const [btnDisable, setBtnDisable] = useState(false);
    const textRef = useRef();
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [pollOptionA, setPollOptionA] = useState("Yes");
    const [pollOptionB, setPollOptionB] = useState("No");
    const [pollOptionC, setPollOptionC] = useState("");
    const [pollOptionD, setPollOptionD] = useState("");
    const [showPollModal, setShowPollModal] = useState(false);
    const [showAiModal, setShowAiModal] = useState(false);


    const [LikesView, setLikesView] = useState(false);
    const [everyone1, setEveryone1] = useState(true);
    const [people1, setPeople1] = useState(false);
    const [noOne1, setNoOne1] = useState(false);
    const [HideLikeViewsControl, setHideLikeViewsControl] = useState(false);
    const [everyone2, setEveryone2] = useState(true);
    const [people2, setPeople2] = useState(false);
    const [noOne2, setNoOne2] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    const [followers, setFollowers] = useState([]);
    const [filteredFollowers, setFilteredFollowers] = useState([]);
    const [showMentions, setShowMentions] = useState(false);
    const [cursorPos, setCursorPos] = useState(0);
    const [isFollowersLoading, setIsFollowersLoading] = useState(false);

    const previewUrl = React.useMemo(() => {
        return fileData ? getStableUrl(fileData) : null;
    }, [fileData]);

    useEffect(() => {
        const fetchFollowers = async () => {
            setIsFollowersLoading(true);
            try {
                const { data } = await axios.get(`/auth/follower-following`);
                console.log("Followers data received:", data);
                const followersData = data.data.followersData || [];
                setFollowers(followersData);
            } catch (error) {
                console.error("Failed to fetch followers", error);
            } finally {
                setIsFollowersLoading(false);
            }
        };
        fetchFollowers();
    }, []);

    const handleCaptionChange = (e) => {
        const val = e.target.value;
        const selectionStart = e.target.selectionStart;
        setCursorPos(selectionStart);

        const words = val.split(/\s+/);
        if (words.filter(w => w.trim() !== "").length <= 32) {
            setCaption(val);
        } else {
            toast.info("Word Limit Reached (32 words)!");
            return;
        }

        // Mention detection
        const textBeforeCursor = val.substring(0, selectionStart);
        const lastAtSymbol = textBeforeCursor.lastIndexOf("@");
        if (lastAtSymbol !== -1 && !textBeforeCursor.substring(lastAtSymbol).includes(" ")) {
            const query = textBeforeCursor.substring(lastAtSymbol + 1);
            const filtered = followers.filter(f =>
                f.username?.toLowerCase().includes(query.toLowerCase()) ||
                f.displayName?.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredFollowers(filtered);
            setShowMentions(true);
        } else {
            setShowMentions(false);
        }
    };

    const insertMention = (user) => {
        const textBeforeAt = caption.substring(0, caption.lastIndexOf("@", cursorPos - 1));
        const textAfterMention = caption.substring(cursorPos);
        const newCaption = `${textBeforeAt}@${user.username} ${textAfterMention}`;
        setCaption(newCaption);
        setShowMentions(false);
        textRef.current.focus();
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handelUpload = () => {
        if (fileData === null) return toast.warn("Please Select image/video !!");
        const validation = validateMediaFile(fileData);
        if (!validation.valid) {
            toast.error(validation.error);
            return;
        }

        setBtnDisable(true);
        const id = toast.loading("Uploading...");

        const formData = new FormData();

        formData.append("userId", userId);
        formData.append("mediaType", fileType);
        formData.append("mediaUrl", fileData);
        formData.append("Enabledpoll", enablePoll ? "true" : "false");
        
        const activePollOptions = [pollOptionA, pollOptionB, pollOptionC, pollOptionD].filter(opt => opt.trim() !== "");
        formData.append("customPollEnabled", (enablePoll && activePollOptions.length > 0) ? "true" : "false");
        formData.append("customPollData", JSON.stringify(activePollOptions));
        
        formData.append("ShowPollResults", showPollResults ? "true" : "false");
        formData.append("caption", caption);
        formData.append("pollDuration", timer);
        formData.append("privacy", `{"everyone":${everyone1},"followers":${people1},"no_one":${noOne1}}`);
        formData.append("tag_privacy", `{"everyone":${everyone2},"followers":${people2},"no_one":${noOne2}}`);
        formData.append("tags", JSON.stringify(tag));
        formData.append("post_hide", "[]"); //NOTE:
        formData.append("tagPeople", "[]"); //NOTE:

        axios
            .post("/post/", formData, {
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadPercentage(percentCompleted);
                },
            })
            .then(({ data }) => {
                toast.update(id, { render: data.message, type: "success", isLoading: false, autoClose: 2000 });
                setBtnDisable(false);
                navigate("/Home");
            })
            .catch((err) => {
                setBtnDisable(false);
                const errorMsg = getFriendlyUploadErrorMessage(err, "Failed to upload post");
                toast.update(id, { render: errorMsg, type: "error", isLoading: false, autoClose: 3000 });
                console.error(err);
            });
    };

    useEffect(() => {
        if (enablePoll) {
            setTimer("1");
            setShowPollResults(true);
        } else {
            setTimer("0");
            setShowPollResults(false);
        }
    }, [enablePoll]);

    return (
        <div className="App">
            <div className="MainContainer">
                <ScrollToTop />
                <Header />
                <div className={`${styles.Container} ${styles.Post}`}>
                    {/* <SmallHeader /> */}
                    <div className={styles.BackButton}>
                        <button onClick={() => { navigate('/Home') }}>
                            <FaArrowLeftLong /> Back
                        </button>
                    </div>
                    <div className={styles.EditPostBody}>
                        <div className={styles.EditPostBodyLeft}>
                            <div className={styles.EditPostBox}>
                                <div className={styles.ImageContainer} onClick={() => imageRef?.current?.click()}>
                                    {fileType === "video" ? (
                                        <video src={previewUrl} controls></video>
                                    ) : (
                                        <img src={previewUrl || Background1} alt="" />
                                    )}
                                    {fileData === null ? <h2>Upload</h2> : <h2>Change</h2>}
                                    <input
                                        type="file"
                                        ref={imageRef}
                                        accept="image/*,video/*"
                                        capture={isMobile ? "environment" : undefined}
                                        style={{ display: "none" }}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (!file) return;
                                            const validation = validateMediaFile(file);
                                            if (!validation.valid) {
                                                toast.error(validation.error);
                                                e.target.value = null;
                                                return;
                                            }
                                            setFileData(file);
                                            if (file.type && file.type.startsWith("video")) setFileType("video");
                                            else setFileType("image");
                                            e.target.value = null;
                                        }}
                                    />
                                </div>
                            </div>

                            {/* <div className={styles.LeftBottom}>
                                <div className={styles.EnablePollMainContainer}>
                                    <EnablePollContainer value={enablePoll} setValue={setEnablePoll} />

                                    <div className={styles.ShowPollResult}>
                                        <p>Show Poll Results</p>
                                        <Switch
                                            onChange={(e) => {
                                                if (enablePoll) setPollResult(e);
                                                else toast.info("Please Enable Poll !");
                                            }}
                                            checked={pollResult}
                                            offColor={"#c4c4c4"}
                                            onColor={"#909AFF"}
                                            offHandleColor={"#959595"}
                                            onHandleColor={"#2E5EE2"}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            activeBoxShadow={"0 0 0px 0px #909AFF"}
                                            height={30}
                                            width={64}
                                        />
                                    </div>
                                </div>
                            </div> */}

                            {!isMobile && (
                                <div className={styles.describeContainer}>
                                    <p>Describe your feeling</p>
                                    <div className={styles.TextAreaContainer}>
                                        <textarea
                                            ref={textRef}
                                            value={caption}
                                            placeholder="Write your caption here..."
                                            onChange={handleCaptionChange}
                                            className={styles.textarea1}></textarea>

                                        {showMentions && (
                                            <div className={styles.MentionsDropdown}>
                                                {filteredFollowers.length > 0 ? (
                                                    filteredFollowers.map((f) => (
                                                        <div key={f._id} className={styles.MentionItem} onClick={() => insertMention(f)}>
                                                            <img src={f.ProfilePic} alt="" />
                                                            <span>{f.displayName || f.username}</span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className={styles.MentionItem}>
                                                        <span>{isFollowersLoading ? "Loading followers..." : "No users found"}</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className={styles.row2}>
                                            <textarea
                                                value={tagText}
                                                placeholder='Add #tags (Example: #Nature #Art)'
                                                onChange={(e) => {
                                                    const newVal = e.target.value.replace(/#\s+/g, '#');
                                                    setTagText(newVal);
                                                    let rawTags = newVal
                                                        .split(/\s+/)
                                                        .filter(t => t.startsWith("#"))
                                                        .map(t => t.replace(/^#/, ""));
                                                    setTag(rawTags);
                                                }}
                                                className={styles.textarea2}></textarea>
                                            <span>
                                                {caption?.split(/\s+/).filter(w => w.trim() !== "").length < 10
                                                    ? `0${caption?.split(/\s+/).filter(w => w.trim() !== "").length}`
                                                    : caption?.split(/\s+/).filter(w => w.trim() !== "").length}
                                                /32
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>

                        <div className={styles.EditPostBodyRight}>
                            <div className={styles.RightInner}>
                                {/* <EnablePollContainer /> */}

                                {/* 👇 Make this Hidden when EnablePollContainer Enable 👇 */}
                                {/* <div className={styles.SetTimerContainer}>
                                    <p>Set Timer</p>
                                    <div className={styles.SetTimerInner}>
                                        <div className={styles.SetTimerInnerLeft}>
                                            <div
                                                className={`${styles.dates} ${timer === "1" ? styles.active : ""}`}
                                                onClick={() => {
                                                    if (enablePoll) setTimer("1");
                                                    else toast.info("Please Enable Poll !");
                                                }}>
                                                1D
                                            </div>
                                            <div
                                                className={`${styles.dates} ${timer === "2" ? styles.active : ""}`}
                                                onClick={() => {
                                                    if (enablePoll) setTimer("2");
                                                    else toast.info("Please Enable Poll !");
                                                }}>
                                                2D
                                            </div>
                                            <div
                                                className={`${styles.dates} ${timer === "7" ? styles.active : ""}`}
                                                onClick={() => {
                                                    if (enablePoll) setTimer("7");
                                                    else toast.info("Please Enable Poll !");
                                                }}>
                                                7D
                                            </div>
                                        </div>
                                        <div className={styles.SetTimerInnerRight}>
                                            <select
                                                defaultValue={timer}
                                                onChange={(e) => {
                                                    if (enablePoll) setTimer(e.target.value);
                                                    else toast.info("Please Enable Poll !");
                                                }}>
                                                <option value="">Set Custom</option>
                                                {Array(15)
                                                    .fill("")
                                                    .map((d, index) => (
                                                        <option key={index} value={index + 1}>
                                                            {index + 1}D
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                </div> */}
                                {/* 👆 Make this Hidden when EnablePollContainer Enable 👆 */}

                                                <div className={styles.LeftBottom}>
                                                    <div className={styles.EnablePollMainContainer}>
                                        <EnablePollContainer 
                                            value={enablePoll} 
                                            setValue={(val) => {
                                                setEnablePoll(val);
                                                if (val) setShowPollModal(true);
                                            }} 
                                            pollOptionA={pollOptionA}
                                            pollOptionB={pollOptionB}
                                            pollOptionC={pollOptionC}
                                            pollOptionD={pollOptionD}
                                            onEditPoll={() => setShowPollModal(true)}
                                        />

                                        <div className={styles.ShowPollResult}>
                                                        <p>Show Poll Results</p>
                                            <Switch
                                                onChange={(e) => {
                                                    if (enablePoll) setShowPollResults(e);
                                                    else toast.info("Please Enable Poll !");
                                                }}
                                                checked={showPollResults}
                                                offColor={"#c4c4c4"}
                                                onColor={"#909AFF"}
                                                offHandleColor={"#959595"}
                                                onHandleColor={"#2E5EE2"}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                height={30}
                                                width={64}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.describeContainer}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                                        <p style={{ margin: 0 }}>Describe your feeling</p>
                                        <button
                                            type="button"
                                            onClick={() => setShowAiModal(true)}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                background: "linear-gradient(135deg, #6366f1, #909aff)",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "14px",
                                                padding: "5px 12px",
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                fontWeight: "600",
                                                boxShadow: "0 2px 8px rgba(99, 102, 241, 0.35)",
                                            }}
                                        >
                                            <PiMagicWandFill /> Ask Fameo
                                        </button>
                                    </div>
                                    <div className={styles.TextAreaContainer}>
                                        <textarea
                                            ref={textRef}
                                            value={caption}
                                                    placeholder="Write your caption here..."
                                            onChange={handleCaptionChange}
                                            className={styles.textarea1}></textarea>

                                        {showMentions && (
                                            <div className={styles.MentionsDropdown}>
                                                {filteredFollowers.length > 0 ? (
                                                    filteredFollowers.map((f) => (
                                                        <div key={f._id} className={styles.MentionItem} onClick={() => insertMention(f)}>
                                                            <img src={f.ProfilePic} alt="" />
                                                            <span>{f.displayName || f.username}</span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className={styles.MentionItem}>
                                                        <span>{followers.length === 0 ? "Loading followers..." : "No users found"}</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className={styles.row2}>
                                            <textarea
                                                value={tagText}
                                                placeholder='Add #tags (Example: #Nature #Art)'
                                                onChange={(e) => {
                                                    const newVal = e.target.value.replace(/#\s+/g, '#');
                                                    setTagText(newVal);
                                                    let rawTags = newVal
                                                        .split(/\s+/)
                                                        .filter(t => t.startsWith("#"))
                                                        .map(t => t.replace(/^#/, ""));
                                                    setTag(rawTags);
                                                }}
                                                className={styles.textarea2}></textarea>
                                            <span>
                                                {caption?.split(/\s+/).filter(w => w.trim() !== "").length < 10
                                                    ? `0${caption?.split(/\s+/).filter(w => w.trim() !== "").length}`
                                                    : caption?.split(/\s+/).filter(w => w.trim() !== "").length}
                                                /32
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.PostContainer}>
                                    <p>Post Setting</p>
                                    <div className={styles.PostCont1}>
                                        {/* <h2>Post</h2> */}
                                        <div className={styles.PostCont1Inn}>
                                            <h5>Likes & View</h5>
                                            <p
                                                onClick={() => {
                                                    setLikesView(!LikesView);
                                                    setHideLikeViewsControl(false);
                                                }}>
                                                Everyone {">"}
                                            </p>
                                        </div>
                                        <div className={styles.PostCont1Inn}>
                                            <h5>Hide like & views control</h5>
                                            <p
                                                onClick={() => {
                                                    setHideLikeViewsControl(!HideLikeViewsControl);
                                                    setLikesView(false);
                                                }}>
                                                0 people {">"}
                                            </p>
                                        </div>
                                        <div className={styles.PostCont1Inn}>
                                            <h5>Allow Comments From</h5>
                                            <p
                                                onClick={() => {
                                                    setLikesView(!LikesView);
                                                    setHideLikeViewsControl(false);
                                                }}>
                                                Everyone {">"}
                                            </p>
                                        </div>
                                        <div className={styles.PostCont1Inn}>
                                            <h5>Post Sharing</h5>
                                            <p
                                                onClick={() => {
                                                    setLikesView(!LikesView);
                                                    setHideLikeViewsControl(false);
                                                }}>
                                                Everyone {">"}
                                            </p>
                                        </div>
                                    </div>

                                    {LikesView && (
                                        <div className={styles.PostCont2}>
                                            <p>Allow Tag from (Likes & View)</p>
                                            <div className={styles.PostCont2Inn}>
                                                <h2>Everyone</h2>
                                                <Switch
                                                    onChange={(e) => {
                                                        setEveryone1(e);
                                                        setPeople1(false);
                                                        setNoOne1(false);
                                                    }}
                                                    checked={everyone1}
                                                    offColor={"#eee"}
                                                    onColor={"#eee"}
                                                    offHandleColor={"#959595"}
                                                    onHandleColor={"#3A0DBB"}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                    height={14}
                                                    width={33}
                                                />
                                            </div>

                                            <div className={styles.PostCont2Inn}>
                                                <h2>People you follow</h2>
                                                <Switch
                                                    onChange={(e) => {
                                                        setEveryone1(false);
                                                        setPeople1(e);
                                                        setNoOne1(false);
                                                    }}
                                                    checked={people1}
                                                    offColor={"#eee"}
                                                    onColor={"#eee"}
                                                    offHandleColor={"#959595"}
                                                    onHandleColor={"#3A0DBB"}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                    height={14}
                                                    width={33}
                                                />
                                            </div>

                                            <div className={styles.PostCont2Inn}>
                                                <h2>No one</h2>
                                                <Switch
                                                    onChange={(e) => {
                                                        setEveryone1(false);
                                                        setPeople1(false);
                                                        setNoOne1(e);
                                                    }}
                                                    checked={noOne1}
                                                    offColor={"#eee"}
                                                    onColor={"#eee"}
                                                    offHandleColor={"#959595"}
                                                    onHandleColor={"#3A0DBB"}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                    height={14}
                                                    width={33}
                                                />
                                            </div>


                                            <p>No One Except Specific Profiles</p>
                                            <div className={styles.PostCont2SearchBar}>
                                                <img src={SearchIcon} alt="" />
                                                <input type="text" name="" id="" placeholder='Search' />
                                            </div>
                                        </div>
                                    )}

                                    {HideLikeViewsControl && (
                                        <div className={styles.PostCont2}>
                                            <p>Allow Tag from (Hide like & views control)</p>
                                            <div className={styles.PostCont2Inn}>
                                                <h2>Everyone</h2>
                                                <Switch
                                                    onChange={(e) => {
                                                        setEveryone2(e);
                                                        setPeople2(false);
                                                        setNoOne2(false);
                                                    }}
                                                    checked={everyone2}
                                                    offColor={"#eee"}
                                                    onColor={"#eee"}
                                                    offHandleColor={"#959595"}
                                                    onHandleColor={"#3A0DBB"}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                    height={14}
                                                    width={33}
                                                />
                                            </div>

                                            <div className={styles.PostCont2Inn}>
                                                <h2>People you follow</h2>
                                                <Switch
                                                    onChange={(e) => {
                                                        setEveryone2(false);
                                                        setPeople2(e);
                                                        setNoOne2(false);
                                                    }}
                                                    checked={people2}
                                                    offColor={"#eee"}
                                                    onColor={"#eee"}
                                                    offHandleColor={"#959595"}
                                                    onHandleColor={"#3A0DBB"}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                    height={14}
                                                    width={33}
                                                />
                                            </div>

                                            <div className={styles.PostCont2Inn}>
                                                <h2>No one</h2>
                                                <Switch
                                                    onChange={(e) => {
                                                        setEveryone2(false);
                                                        setPeople2(false);
                                                        setNoOne2(e);
                                                    }}
                                                    checked={noOne2}
                                                    offColor={"#eee"}
                                                    onColor={"#eee"}
                                                    offHandleColor={"#959595"}
                                                    onHandleColor={"#3A0DBB"}
                                                    uncheckedIcon={false}
                                                    checkedIcon={false}
                                                    activeBoxShadow={"0 0 0px 0px #909AFF"}
                                                    height={14}
                                                    width={33}
                                                />
                                            </div>

                                            <p>No One Except Specific Profiles</p>
                                            <div className={styles.PostCont2SearchBar}>
                                                <img src={SearchIcon} alt="" />
                                                <input type="text" name="" id="" placeholder='Search' />
                                            </div>
                                        </div>
                                    )}

                                    <button className={styles.uploadBtn} disabled={btnDisable} onClick={handelUpload}>
                                        {btnDisable ? (
                                            <>
                                                <div>
                                                    <FallingLines
                                                        color="#fff"
                                                        width="60"
                                                        visible={true}
                                                        ariaLabel="falling-lines-loading"
                                                    />
                                                    {uploadPercentage}%
                                                </div>
                                                <span style={{ width: `${uploadPercentage}%` }}></span>
                                            </>
                                        ) : (
                                            "Upload"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showPollModal && (
                <CustomPollModal 
                    pollOptionA={pollOptionA} setPollOptionA={setPollOptionA}
                    pollOptionB={pollOptionB} setPollOptionB={setPollOptionB}
                    pollOptionC={pollOptionC} setPollOptionC={setPollOptionC}
                    pollOptionD={pollOptionD} setPollOptionD={setPollOptionD}
                    onClose={() => setShowPollModal(false)}
                    onContinue={() => setShowPollModal(false)}
                />
            )}

            <AskFameoAssistantModal
                isOpen={showAiModal}
                onClose={() => setShowAiModal(false)}
                mediaFile={fileData}
                type="post"
                onApplyCaption={(generatedCaption, hashtags) => {
                    const clean = cleanCaptionSentence(generatedCaption);
                    setCaption(clean);
                    if (hashtags && hashtags.length > 0) {
                        const cleanedTags = hashtags.map((t) => cleanCaptionSentence(t).replace(/^#*/, ""));
                        setTag(cleanedTags);
                        setTagText(hashtags.join(" "));
                    }
                }}
            />
        </div>
    );
}

export default UploadPost2


